import { PauseIcon } from '../../../../../../assets/svg/payment-links-custom/PauseIcon';
import { StopIcon } from '../../../../../../assets/svg/payment-links-custom/StopIcon';
import {
	ButtonFooter,
	Card,
	CardFooter,
	CardHeader,
	CardSubTitle,
	CardTitle,
	TextContainer,
} from './styles';

interface ActionCardProps {
	type: 'PAUSE' | 'FINALIZED';
	handlePauseLink: () => void;
	handleFinalizeLink: () => void;
}

const ActionCard = ({ type, handlePauseLink, handleFinalizeLink }: ActionCardProps) => {
	const renderByType = () => {
		switch (type) {
			case 'PAUSE':
				return (
					<Card type={type}>
						<CardHeader>
							<PauseIcon />
						</CardHeader>
						<TextContainer>
							<CardTitle>Pausar la recepción de pagos</CardTitle>
							<CardSubTitle>
								Tus clientes no podrán realizar pagos mientras esta opción esté activa, pero podrás
								reactivarlo en cualquier momento.
							</CardSubTitle>
						</TextContainer>
						<CardFooter>
							<ButtonFooter typeLink="PAUSE" onClick={handlePauseLink}>
								Pausar
							</ButtonFooter>
						</CardFooter>
					</Card>
				);
			case 'FINALIZED':
				return (
					<Card type={type}>
						<CardHeader>
							<StopIcon />
						</CardHeader>
						<TextContainer>
							<CardTitle>Finalizar enlace</CardTitle>
							<CardSubTitle>
								Esta acción no podrá ser revertida, tus clientes no podrán realizar más pagos a
								través de este enlace.
							</CardSubTitle>
						</TextContainer>
						<CardFooter>
							<ButtonFooter typeLink="FINALIZED" onClick={handleFinalizeLink}>
								Finalizar
							</ButtonFooter>
						</CardFooter>
					</Card>
				);

			default:
				return null;
		}
	};

	return <>{renderByType()}</>;
};

export { ActionCard };
